import firebase from "./FirebaseManager"

// other firebase module
import {
    GoogleAuthProvider,
    signInWithPopup, signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    onAuthStateChanged
} from "firebase/auth";
import { doc, query, getDocs, getDoc, collection, where, addDoc, setDoc, updateDoc } from "firebase/firestore";

// downloadHandler
const downloadHandler = (fileName = "") => {
    return new Promise((resolve, reject) => {
        const storage = firebase.storage
        firebase.getDownloadURL(firebase.ref(storage, fileName))
            .then(url => {
                resolve(url)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
    })
}

// auth api
const registerWithEmail = async (email, password, name = "User") => {
    try {
        const res = await createUserWithEmailAndPassword(firebase.auth, email, password);
        const user = res.user;
        await setDoc(doc(firebase.db, "users", user.uid), {
            uid: user.uid,
            name: name,
            authProvider: "local",
            email: email,
            status: ""
        });
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
}

const logInWithEmail = async (email, password) => {
    return new Promise(async (reslove, reject) => {
        try {
            await signInWithEmailAndPassword(firebase.auth, email, password)
            reslove(true)
        } catch (err) {
            console.log(err);
            reject(err)
        }
    })
}

const signInWithGoogle = async () => {
    const googleProvider = new GoogleAuthProvider();
    try {
        const res = await signInWithPopup(firebase.auth, googleProvider);

        const user = res.user;
        const q = query(collection(firebase.db, "users"), where("uid", "==", user.uid));
        const docs = await getDocs(q);
        if (docs.docs.length === 0) {
            await setDoc(doc(firebase.db, "users", user.uid), {
                uid: user.uid,
                name: user.displayName,
                authProvider: "google",
                email: user.email,
                status: ""
            });
        }
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
}

const logOut = () => {
    signOut(firebase.auth);
}

const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(firebase.auth, email);
        alert("Password reset link sent!");
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

const getStateChange = async (cb) => {
    onAuthStateChanged(firebase.auth, (user) => {
        cb(user)
    })
}

const updateUserDoc = async (user = null, data = {}) => {
    if (user == null)
        return
    try {
        const collectRef = collection(firebase.db, "users")
        await updateDoc(doc(collectRef, user.uid), {
            ...data
        })
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
}

const getUserDoc = async (user = null) => {
    if (user == null)
        return

    try {
        const docRef = doc(collection(firebase.db, "users"), user.uid)
        const docSnap = await getDoc(docRef)
        var userData = {}
        if (docSnap.exists())
            userData = docSnap.data()

        return userData
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
}

export default {
    downloadHandler,
    registerWithEmail,
    logInWithEmail, signInWithGoogle, logOut,
    sendPasswordReset,
    getStateChange,
    updateUserDoc,
    getUserDoc
}